import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6k5xkw1g4n: FaireBrandEntity = {
  token: "b_6k5xkw1g4n",
  type: "brand",
  name: "Fantasy Gifts",
  avatarUrl:
    "https://cdn.faire.com/fastly/9a9acb28835257dd5e94c2884070969e161380b54f0f17b0ed70da4624155a74.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/19a3f217dc9ea1e71882cd7cd5f9b8690b3ed1cf933367583b2849152517cb79.png",
  logoUrl:
    "https://cdn.faire.com/fastly/9a9acb28835257dd5e94c2884070969e161380b54f0f17b0ed70da4624155a74.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/19a3f217dc9ea1e71882cd7cd5f9b8690b3ed1cf933367583b2849152517cb79.png",
  location: "Manteca, CA, USA",
  minimumOrderDollars: 200,
  rating: 4.8,
  reviewCount: 701,
  isInsider: true,
  description:
    "Fantasy Gifts has been in business since 1985!  We are always sourcing new products from all over the world.  Up till recently we have been making trips to China and India every year to source new goods and factories to work with. ",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:58.131Z",
    importedBy: "entity-db-cli",
  },
};
